module.exports = __webpack_public_path__ + "static/media/Iconly-Light-Wallet.3b116233.svg";